module.exports = __webpack_public_path__ + "img/suspicious_person.37bdbf2d.jpg";